import type {
    AuthenticationRequest,
    AuthenticationResponse,
    SendOtpRequest,
    SessionInfoResponse,
} from '@leanpay/models'
import { HttpClient } from '@leanpay/http-client'
import { storage } from '@leanpay/local-storage'
import { STORAGE_KEY } from '@leanpay/utils'

import { errorHandler } from '../errorHandler'
import { verificationInterceptor } from '../interceptors'

class AuthService {
    _httpClient = new HttpClient({
        config: { baseURL: undefined },
        interceptorConfig: {
            onRequestFulfilled: verificationInterceptor,
            onRejected: errorHandler,
        },
    })

    private _authenticateUrl = 'api/authenticate'
    private _sendOtpUrl = 'api/authenticate/send-otp'
    private _resendOtpUrl = 'api/authenticate/resend-otp'
    private _resendOtpOverVoiceUrl = 'api/authenticate/send-otp-over-voice'
    private _sessionInfoUrl = 'api/authenticate/session-info'
    // TODO: Rename services so they make sense, and move them to the correct service file checkout, vendor, dashboard, etc.
    async requestOtp(payload: SendOtpRequest) {
        const { data } = await this._httpClient.post(this._sendOtpUrl, payload)

        return data
    }

    async resendOtp(payload: SendOtpRequest) {
        const { data } = await this._httpClient.post(this._resendOtpUrl, payload)

        return data
    }

    async resendOtpOverVoice(payload: SendOtpRequest) {
        const { data } = await this._httpClient.post(this._resendOtpOverVoiceUrl, payload)

        return data
    }

    async authenticate(payload: AuthenticationRequest) {
        const { data } = await this._httpClient.post<AuthenticationResponse>(
            this._authenticateUrl,
            payload,
        )

        return data
    }

    async getSessionInfo() {
        const { data } = await this._httpClient.get<SessionInfoResponse>(this._sessionInfoUrl)

        storage.save(STORAGE_KEY.SESSION_INFO, data)

        return data
    }
}

export const authService = new AuthService()
